import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'outline-light' | 'outline-dark' | 'dark';
type Size = 'sm' | 'md' | 'lg';
interface ButtonLinkProps {
  to?: string;
  href?: string;
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
  ariaLabel?: string;
  newTab?: boolean;
}
const variants: Record<Variant, string> = {
  primary: 'bg-accent text-white hover:bg-accent-bright',
  'outline-light': 'border border-white/60 text-white hover:bg-white hover:text-ink hover:border-white',
  'outline-dark': 'border border-navy/40 text-navy hover:bg-navy hover:text-white hover:border-navy',
  dark: 'bg-navy text-white hover:bg-midnight'
};
const sizes: Record<Size, string> = {
  sm: 'h-10 px-4 text-[13px]',
  md: 'h-12 px-6 text-sm',
  lg: 'h-14 px-8 text-[15px]'
};
export function ButtonLink({
  to,
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ariaLabel,
  newTab
}: ButtonLinkProps) {
  const cls = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[3px] font-display font-semibold uppercase tracking-[0.08em] transition-[background-color,color,border-color,transform] duration-150 ease-out active:scale-[0.98] ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} className={cls} aria-label={ariaLabel} {...newTab ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-534" data-mp="2sfe4v3awfxzv">
        {children}
      </a>;
  }
  return <Link to={to ?? '/'} className={cls} aria-label={ariaLabel} data-id="element-535" data-mp="20oztbdqcyxrd">
      {children}
    </Link>;
}